import { Component, OnInit, Input } from '@angular/core';
import { Usuario } from '@/Interfaces';
import { AutenticacionService, GlobalService } from '@/Servicios';
import { Router, ActivatedRoute } from '@angular/router';
import { Mensaje, respuestaMensaje } from '@/Interfaces/shared/mensaje';

@Component({
  selector: 'app-top-bar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  nombreMod: string[] = [];
  public urlRutaRegreso: string = "";
  modulosPadres: string;
  moduloActual: string;
  logoUsuario: string = "";
  public Mensaje: Mensaje;
  public abrirVentana: boolean = false;

  public OK: boolean = false;
  public ruta1: string = '';

  usuario: Usuario = {
    cambioClave: '',
    correo: '',
    empleadorId: '',
    empleadorTipoId: '',
    error: 0,
    estadoAfiliacion: '',
    estadoAfiliacionPAC: '',
    fechaCreacion: '',
    idEstado: 0,
    idEstadoAfiliacion: 0,
    idEstadoAfiliacionPAC: 0,
    idPerfil: '',
    idUsuario: 0,
    identificacion: '',
    imagenUsuario: '',
    mensaje: '',
    nombreCompleto: '',
    perfil: '',
    sedePrimaria: '',
    sucursalDependiente: '',
    tipoAfiliado: '',
    tipoIdentificacion: '',
    token: '',
    userPassword: null,
    usuarioPAC: false,
    sede: {

    }
  }
  notificaciones: number = 0;
  global: GlobalService;
  authenticationService: AutenticacionService;
  @Input()
  set nombreModulo(nombreModulo: string[]) {
    this.nombreMod = nombreModulo;
    this.modulosPadres = '';
    if (this.nombreMod != null) {
      this.moduloActual = this.nombreMod[0];
      if (this.nombreMod.length > 1) {
        for (let i = this.nombreMod.length - 1; i >= 1; i--) {
          this.modulosPadres = ` ${this.modulosPadres} ${this.nombreMod[i]} >`;
        }
      }
    }
  }

  constructor(private _router: Router, private _authenticationService: AutenticacionService, private globalService: GlobalService, private activatedRoute: ActivatedRoute) {
    this.authenticationService = _authenticationService;

    if (this.globalService.usuario) {
      this.usuario = this.globalService.usuario;
      this.global = this.globalService;
      if (this.usuario) {
        this.logoUsuario = this.usuario.imagenUsuario ? this.usuario.imagenUsuario : this.global.defaultImage;

      }
    } else {
      this.global = this.globalService;
      this.logoUsuario = this.global.defaultImage;
    }
  }

  logout() {
    this._router.navigate(['autenticacion/login'], { skipLocationChange: true });
    sessionStorage.clear();
  }

   ngOnInit() {    
    this.urlRutaRegreso = JSON.parse(sessionStorage.getItem('configOficina')).rutaRegreso;
  }

  Notification() {
    this.abrirVentana = true;
  }
  async recibirRespuestaMensaje() {
    this.abrirVentana = false;
  }
}
